import React from 'react'

import Link from 'src/components/link/index'
import Image from 'src/components/image/dynamic'

import { SlideinWrap, SlideinItem } from 'src/components/slidein/index'

import * as styles from './profile.module.scss'


const Profile = ({ name, image, description, instagramUrl }) => {

    return (
        <SlideinWrap className={styles.profile}>
            <div className={styles.left}>
                <SlideinItem className={styles.image}>
                    <Image imagePC={image} />
                </SlideinItem>
            </div>
            <div className={styles.right}>
                <SlideinItem delay={100} tagName="h3" className={styles.name}>
                    {instagramUrl ? (
                        <Link to={instagramUrl}><span>{name}</span></Link>
                    ) : (
                        <div><span>{name}</span></div>
                    )}
                </SlideinItem>
                <SlideinItem delay={300} className={styles.description}>
                    <p>{description}</p>
                </SlideinItem>
            </div>
        </SlideinWrap>
    )
}

export default Profile